module.exports = __webpack_public_path__ + "img/rws_logo.40c79e30.png";